<template>
    <form ref="uploadForm" method="post" :action="endpoint" enctype="multipart/form-data">
        <input type="hidden" name="_token" :value="csrfToken">
        <input class="hidden" ref="fileInput" @change="inputChange" type="file" name="attachments[]" accept="image/*" multiple>
        <btn class="btn--primary"
            type="button"
            @click.native="$refs.fileInput.click()"
            :loading="loading"
        ><slot></slot></btn>
    </form>
</template>

<script>
export default {

    props: {
        endpoint: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            loading: false
        }
    },

    computed: {
        csrfToken: () => window.App.csrfToken
    },

    methods: {
        inputChange(e) {
            if (! e.target.files.length) {
                return;
            }
            this.loading = true;
            this.$refs.uploadForm.submit();
        }
    }
}
</script>
